var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loggedIn)?_c('app-nav'):_vm._e(),_c('NotificationContainer'),_c('div',{staticClass:"lc-main-container",class:{'lc-landing-page-container': !_vm.loggedIn}},[_c('router-view',{staticClass:"page"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }